import Deadlines from "./deadlines";

export default Deadlines;
